export default class CacheExpirations {
  // Use a short amount of time that is big enough for at least caching items druing a page load
  // and short enough to reflect changes from other users as soon as possible
  static readonly oneMinute = 60 * 1000; // One minute
  static readonly oneHour = 60 * 60 * 1000; // One hour
}
